export default __webpack_public_path__ + "5560ee0612178c04e11d222b59a0ec43.jpg";